$.TemplateArticles = {
    filterArticlesTimeout: undefined,

    filterArticles: function (filters) {
        if (this.filterArticlesTimeout)
            clearTimeout(this.filterArticlesTimeout);

        const url = new URL(window.location.href);
        url.searchParams.delete("page");
        url.searchParams.delete("category");
        url.searchParams.delete("months");

        if (!!filters["category"])
            url.searchParams.set(
                "category",
                JSON.stringify(filters["category"])
            );

        if (!!filters["months"])
            url.searchParams.set("months", JSON.stringify(filters["months"]));

        this.filterArticlesTimeout = setTimeout(
            () => (window.location.href = url.toString()),
            500
        );
    },

    changePage: function (page) {
        const url = new URL(window.location.href);
        url.searchParams.set("page", page);
        window.location.href = url.toString();
    },
};

$(document).ready(function () {
    $(".tpl-articles #article-filters").on("change", function (e) {
        e.stopPropagation();

        let filters = {};

        $(".tpl-articles #article-filters input:checked").each(function (
            index,
            input
        ) {
            const property = $(input).data("property");
            const value = $(input).data("value");

            if (!filters[property]) filters[property] = [];
            filters[property].push(value);
        });

        $.TemplateArticles.filterArticles(filters);
    });

    $(".tpl-articles #article-filters .form-check").on("click", function (e) {
        e.stopPropagation();
        const input = $(this).find("input");
        input.prop("checked", !input.prop("checked"));
        input.trigger("change");
    });

    if ($(window).width() < 768)
        $(".tpl-articles .accordion-collapse").removeClass("show");
});
